import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { registerSessionExpiredHandler } from '../services/api';

// Mounted once inside <BrowserRouter> (see App.js) so it has access to
// useNavigate/useAuth's logout - registers the shared 401 handler
// services/api.js's apiFetch calls on every unauthenticated/expired
// response (docs/DECISIONS.md, "Bug-report batch: session/exam-flow/
// notification/curriculum fixes"). This module can't call hooks itself
// (it's not a component), hence the indirection. Renders nothing.
export default function SessionExpiryHandler() {
  const navigate = useNavigate();
  const { logout } = useAuth();

  useEffect(() => {
    registerSessionExpiredHandler(() => {
      if (window.location.pathname === '/login') return;
      logout();
      navigate('/login', { replace: true, state: { from: window.location.pathname + window.location.search } });
    });
  }, [navigate, logout]);

  return null;
}
